function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t(require("popper.js")) : "function" == typeof define && define.amd ? define(["popper.js"], t) : (e = e || self).VuePopper = t(e.Popper);
}(this, function (e) {
  "use strict";

  function t(e, t, o) {
    e && t && o && (document.addEventListener ? e.addEventListener(t, o, !1) : e.attachEvent("on" + t, o));
  }

  function o(e, t, o) {
    e && t && (document.removeEventListener ? e.removeEventListener(t, o, !1) : e.detachEvent("on" + t, o));
  }

  e = e && e.hasOwnProperty("default") ? e["default"] : e;
  var n = {
    props: {
      tagName: {
        type: String,
        "default": "span"
      },
      trigger: {
        type: String,
        "default": "hover",
        validator: function validator(e) {
          return ["clickToOpen", "click", "clickToToggle", "hover", "focus"].indexOf(e) > -1;
        }
      },
      delayOnMouseOver: {
        type: Number,
        "default": 10
      },
      delayOnMouseOut: {
        type: Number,
        "default": 10
      },
      disabled: {
        type: Boolean,
        "default": !1
      },
      content: String,
      enterActiveClass: String,
      leaveActiveClass: String,
      boundariesSelector: String,
      reference: {},
      forceShow: {
        type: Boolean,
        "default": !1
      },
      dataValue: {
        "default": null
      },
      appendToBody: {
        type: Boolean,
        "default": !1
      },
      visibleArrow: {
        type: Boolean,
        "default": !0
      },
      transition: {
        type: String,
        "default": ""
      },
      stopPropagation: {
        type: Boolean,
        "default": !1
      },
      preventDefault: {
        type: Boolean,
        "default": !1
      },
      options: {
        type: Object,
        "default": function _default() {
          return {};
        }
      },
      rootClass: {
        type: String,
        "default": ""
      }
    },
    data: function data() {
      return {
        referenceElm: null,
        popperJS: null,
        showPopper: !1,
        currentPlacement: "",
        popperOptions: {
          placement: "bottom",
          computeStyle: {
            gpuAcceleration: !1
          }
        }
      };
    },
    watch: {
      showPopper: function showPopper(e) {
        e ? (this.$emit("show", this), this.popperJS && this.popperJS.enableEventListeners(), this.updatePopper()) : (this.popperJS && this.popperJS.disableEventListeners(), this.$emit("hide", this));
      },
      forceShow: {
        handler: function handler(e) {
          this[e ? "doShow" : "doClose"]();
        },
        immediate: !0
      },
      disabled: function disabled(e) {
        e && (this.showPopper = !1);
      }
    },
    created: function created() {
      this.appendedArrow = !1, this.appendedToBody = !1, this.popperOptions = Object.assign(this.popperOptions, this.options);
    },
    mounted: function mounted() {
      switch (this.referenceElm = this.reference || this.$slots.reference[0].elm, this.popper = this.$slots["default"][0].elm, this.trigger) {
        case "clickToOpen":
          t(this.referenceElm, "click", this.doShow), t(document, "click", this.handleDocumentClick);
          break;

        case "click":
        case "clickToToggle":
          t(this.referenceElm, "click", this.doToggle), t(document, "click", this.handleDocumentClick);
          break;

        case "hover":
          t(this.referenceElm, "mouseover", this.onMouseOver), t(this.popper, "mouseover", this.onMouseOver), t(this.referenceElm, "mouseout", this.onMouseOut), t(this.popper, "mouseout", this.onMouseOut);
          break;

        case "focus":
          t(this.referenceElm, "focus", this.onMouseOver), t(this.popper, "focus", this.onMouseOver), t(this.referenceElm, "blur", this.onMouseOut), t(this.popper, "blur", this.onMouseOut);
      }
    },
    methods: {
      doToggle: function doToggle(e) {
        this.stopPropagation && e.stopPropagation(), this.preventDefault && e.preventDefault(), this.forceShow || (this.showPopper = !this.showPopper);
      },
      doShow: function doShow() {
        this.showPopper = !0;
      },
      doClose: function doClose() {
        this.showPopper = !1;
      },
      doDestroy: function doDestroy() {
        this.showPopper || (this.popperJS && (this.popperJS.destroy(), this.popperJS = null), this.appendedToBody && (this.appendedToBody = !1, document.body.removeChild(this.popper.parentElement)));
      },
      createPopper: function createPopper() {
        var t = this;
        this.$nextTick(function () {
          if (t.visibleArrow && t.appendArrow(t.popper), t.appendToBody && !t.appendedToBody && (t.appendedToBody = !0, document.body.appendChild(t.popper.parentElement)), t.popperJS && t.popperJS.destroy && t.popperJS.destroy(), t.boundariesSelector) {
            var o = document.querySelector(t.boundariesSelector);
            o && (t.popperOptions.modifiers = Object.assign({}, t.popperOptions.modifiers), t.popperOptions.modifiers.preventOverflow = Object.assign({}, t.popperOptions.modifiers.preventOverflow), t.popperOptions.modifiers.preventOverflow.boundariesElement = o);
          }

          t.popperOptions.onCreate = function () {
            t.$emit("created", t), t.$nextTick(t.updatePopper);
          }, t.popperJS = new e(t.referenceElm, t.popper, t.popperOptions);
        });
      },
      destroyPopper: function destroyPopper() {
        o(this.referenceElm, "click", this.doToggle), o(this.referenceElm, "mouseup", this.doClose), o(this.referenceElm, "mousedown", this.doShow), o(this.referenceElm, "focus", this.doShow), o(this.referenceElm, "blur", this.doClose), o(this.referenceElm, "mouseout", this.onMouseOut), o(this.referenceElm, "mouseover", this.onMouseOver), o(document, "click", this.handleDocumentClick), this.showPopper = !1, this.doDestroy();
      },
      appendArrow: function appendArrow(e) {
        if (!this.appendedArrow) {
          this.appendedArrow = !0;
          var t = document.createElement("div");
          t.setAttribute("x-arrow", ""), t.className = "popper__arrow", e.appendChild(t);
        }
      },
      updatePopper: function updatePopper() {
        this.popperJS ? this.popperJS.scheduleUpdate() : this.createPopper();
      },
      onMouseOver: function onMouseOver() {
        var e = this;
        clearTimeout(this._timer), this._timer = setTimeout(function () {
          e.showPopper = !0;
        }, this.delayOnMouseOver);
      },
      onMouseOut: function onMouseOut() {
        var e = this;
        clearTimeout(this._timer), this._timer = setTimeout(function () {
          e.showPopper = !1;
        }, this.delayOnMouseOut);
      },
      handleDocumentClick: function handleDocumentClick(e) {
        this.$el && this.referenceElm && !this.elementContains(this.$el, e.target) && !this.elementContains(this.referenceElm, e.target) && this.popper && !this.elementContains(this.popper, e.target) && (this.$emit("documentClick", this), this.forceShow || (this.showPopper = !1));
      },
      elementContains: function elementContains(e, t) {
        return "function" == typeof e.contains && e.contains(t);
      }
    },
    destroyed: function destroyed() {
      this.destroyPopper();
    }
  };
  var r = n;
  n.__file = "popper.js.vue";
  return function (e, t, o, n, r, s, i, p, c, a) {
    "function" == typeof i && (c = p, p = i, i = !1);
    var d = "function" == typeof o ? o.options : o;
    var l;
    if (e && e.render && (d.render = e.render, d.staticRenderFns = e.staticRenderFns, d._compiled = !0, r && (d.functional = !0)), n && (d._scopeId = n), s ? (l = function l(e) {
      (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), t && t.call(this, c(e)), e && e._registeredComponents && e._registeredComponents.add(s);
    }, d._ssrRegister = l) : t && (l = i ? function () {
      t.call(this, a(this.$root.$options.shadowRoot));
    } : function (e) {
      t.call(this, p(e));
    }), l) if (d.functional) {
      var _e = d.render;

      d.render = function (t, o) {
        return l.call(o), _e(t, o);
      };
    } else {
      var _e2 = d.beforeCreate;
      d.beforeCreate = _e2 ? [].concat(_e2, l) : [l];
    }
    return o;
  }({
    render: function render() {
      var e = this,
          t = e.$createElement,
          o = e._self._c || t;
      return o(e.tagName, {
        tag: "component"
      }, [o("transition", {
        attrs: {
          name: e.transition,
          "enter-active-class": e.enterActiveClass,
          "leave-active-class": e.leaveActiveClass
        },
        on: {
          "after-leave": e.doDestroy
        }
      }, [o("span", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !e.disabled && e.showPopper,
          expression: "!disabled && showPopper"
        }],
        ref: "popper",
        "class": e.rootClass
      }, [e._t("default", [e._v(e._s(e.content))])], 2)]), e._v(" "), e._t("reference")], 2);
    },
    staticRenderFns: []
  }, void 0, r, void 0, !1, void 0, void 0, void 0);
});